import { useIsFetching } from 'react-query';

export const useIsFetchingExchangeRate = () =>
  Boolean(useIsFetching(['currencyExchangeRate']));
